import * as React from 'react';
import '../css/banner-image.sass';
import ImageDescription from './ImageDescription';

interface BannerImageProps {
  image: string;
  title: string;
  channelTitle: string;
  channelImg: string;
  time: string;
  description: string;
  theme?: 'night' | 'day';
}

export default function BannerImage(props: BannerImageProps) {
  const { theme = 'day' } = props;
  return (
    <div className="banner-image">
      <img alt={props.title} src={props.image} />
      <ImageDescription
        showName={props.title}
        pkgName={props.channelTitle}
        pkgImgUrl={props.channelImg}
        showTiming={props.time}
        description={props.description}
        theme={theme}
      />
    </div>
  );
}
